import { gql } from "@apollo/client";

export const DEACTIVATE_USER = gql`
  mutation ($id: Int!) {
    deactivateAccount(id: $id) {
      id
      firstName
      lastName
      summary
      timeZone
      createdOn
      updatedOn
    }
  }
`;

export const REACTIVATE_USER = gql`
  mutation ($id: Int!) {
    reactivateAccount(id: $id) {
      id
      firstName
      lastName
      summary
      timeZone
      createdOn
      updatedOn
    }
  }
`;
